import { types } from "../types/types";

const initialState = {
  catalogCountry: {},
  catalogCountrys: [],
  catalogCountrysP: [],
  catalogCountrysS: [],

  totalItemsP: 0,
  totalPagesP: 0,
  currentPageP: 0,
  
  totalItemsS: 0,
  totalPagesS: 0,
  currentPageS: 0,
  searchTextState: "",
};
export const catalogCountryReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.COUNTRY_SELECT:
      return {
        ...state,
        catalogCountry: action.payload,
      };

    case types.COUNTRY_UPDATE:
      if (state.catalogCountrysS.length > 0) {
        return {
          ...state,
          catalogCountrysS: state.catalogCountrysS.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
          catalogCountrysP: state.catalogCountrysP.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
        };
      } else {
        return {
          ...state,
          catalogCountrysP: state.catalogCountrysP.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
        };
      }

    case types.COUNTRY_DELETE:
      if (state.catalogCountrysS.length > 0) {
        return {
          ...state,
          catalogCountrysS: state.catalogCountrysS.filter((usr) => usr.id !== action.payload),
          catalogCountrysP: state.catalogCountrysP.filter((usr) => usr.id !== action.payload),
          catalogCountry: {},
        };
      } else {
        return {
          ...state,
          catalogCountrysP: state.catalogCountrysP.filter((usr) => usr.id !== action.payload),
          catalogCountry: {},
        };
      }

    case types.COUNTRY_START_LOADING:
      //console.log("--->JT, Reducer catalogCountrys, action.payload", action.payload);
      return {
        ...state,
        catalogCountrys: action.payload,
      };

    case types.COUNTRY_START_LOADING_PAGINATED:
      return {
        ...state,
        catalogCountrysP: action.payload.countrysP,
        totalItemsP: action.payload.totalItems,
        totalPagesP: action.payload.totalPages,
        currentPageP: action.payload.currentPage,
      };

    case types.COUNTRY_START_SEARCH:
      return {
        ...state,
        catalogCountrysS: action.payload,
      };

    case types.COUNTRY_START_SEARCH_PAGINATED:
      return {
        ...state,
        catalogCountrysS: action.payload.countrysP,
        totalItemsS: action.payload.totalItems,
        totalPagesS: action.payload.totalPages,
        currentPageS: action.payload.currentPage,
      };

    case types.COUNTRY_CLEAN_SEARCH_PAGINATED:
      return {
        ...state,
        catalogCountrysS: [],
      };

    case types.COUNTRY_CLEAN:
      return {
        ...state,
        catalogCountry: {},
      };

    case types.COUNTRY_START_REGISTER:
      return {
        ...state,
        catalogCountry: action.payload,
      };

    case types.COUNTRY_SET_SEARCH_TEXT:
      return {
        ...state,
        searchTextState: action.payload,
      };

    case types.USER_CLEAN_SEARCH_TEXT:
      return {
        ...state,
        searchTextState: "",
      };

    default:
      return state;
  }
};
